import React from 'react'

export const Social = () => {
  return (
    <div className="home_social">
        <a href="https://www.facebook.com/profile.php?id=100094819833359" className="home_social_icone" target='_blank' rel="noreferrer">
          <i className="uil uil-facebook-f"></i>
        </a>
        <a href="https://www.linkedin.com/in/soufiane-amama/" className="home_social_icone" target='_blank' rel="noreferrer">
          <i className="uil uil-linkedin-alt"></i>
        </a>
        <a href="https://github.com/Soufiane-Amama" className="home_social_icone" target='_blank' rel="noreferrer">
          <i className="uil uil-github-alt"></i>
        </a>
    </div>
  )
}
